import http from './httpService'

export async function getDnaData() {
    try {
        const res: any = await http.get('/dna/data')
        return res
    } catch (error) {
        console.error('DAN data fetch error::', error)
    }
}